import 'css-chunksrc/client/scenes/addPlanzoneResourceToProjects/projectsSelection/zones/zone/projects/project/styles.scss';export default {
  "project": "_project_8dssq_1",
  "icon": "_icon_8dssq_11",
  "name": "_name_8dssq_19"
};